import style from './style.scss';

/**
 * A Button component which renders a stylised button element. The content
 * displayed inside the button is specified via children elements.
 *
 * props:
 * - wide: should this be a wide button or not (true or false)
 * - isActive: is the button currently active (true or false)
 * - isDisabled: is the button currently disabled (true or false)
 * - data: Extra data for this button, passed into the provided clickHandler as the sole argument.
 * - clickHandler: handler function which responds to button click events.
 * - buttonTitle: title for this button
 */

const Button = props => {

	const cssClass = props.wide ? [style.button_wide] : [style.button];

	if (props.isActive) {
		cssClass.push(style.active);
	}

	const onClick = () => props.clickHandler(props.data);

	return (
		<button class={cssClass.join(' ')}
		        disabled={props.isDisabled}
		        title={props.buttonTitle}
		        onClick={onClick}>
			{props.children}
		</button>
	);

};

export default Button;



// WEBPACK FOOTER //
// ./components/button/index.js